"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const types_1 = require("../types");
const BasicNode_1 = require("./BasicNode");
const validations_1 = require("../validations");
const utils_1 = require("../helper/utils");
const defaultCode =
  "async function process(){\n" +
  "  let result = 0;\n" +
  "  let {collection,region} = context;\n" +
  "  for(let i = 0;i< collection.length; i++){\n" +
  "    result += collection[i].key;\n" +
  "  }\n" +
  "  exit(null,result)\n" +
  "}\n" +
  "process().catch(exit);";
class CustomNode extends BasicNode_1.BasicNode {
  constructor(props) {
    if (!props) props = { type: types_1.NODE_TYPES.CUSTOM };
    if (props.type !== types_1.NODE_TYPES.CUSTOM)
      throw new Error("Invalid Node type");
    super(props);
  }
  deserialize(data) {
    let nodeData = data || this.getNodeData();
    let deserializeData = {
      link: "",
      variables: {}
    };
    if (nodeData) {
      let type = nodeData.link || "custom";
      deserializeData = {
        link: type,
        variables: nodeData.variables,
        code:
          type === "custom"
            ? { data: nodeData.code || defaultCode, error: false }
            : undefined
      };
    }
    return deserializeData;
  }
  serialize(uiData) {
    let type = uiData.link || "custom";
    let data = {
      link: type !== "custom" ? type : undefined,
      variables: uiData.variables,
      code: type === "custom" && uiData.code ? uiData.code.data : undefined
    };
    return data;
  }
  getAttachedApis(selectedResource) {
    return this.getAttachedApisFromParent(selectedResource);
  }
  /**
   *  return extra resources which are path resources
   *  e.g for resource node with addons resources are
   *  resourceNodeId-Instances, resourceNodeId-Instances-addons-Volumes, resourceNodeId-Instances-addOns-SecurityGroups
   *  returns filterNodeId-Instances-addons-Volumes, filterNodeId-Instances-addOns-SecurityGroups
   *
   */
  async getAvailableResourcesForAllPaths() {
    let availableResources = [];
    const selectedResource = this.getSelectedResource();
    if (!selectedResource || !selectedResource.nodeRef) return [];
    let options = await selectedResource.nodeRef.getAvailableResources();
    options = options.filter(x =>
      utils_1.selectedResourceNotEquals(x, selectedResource)
    );
    for (let option of options) {
      let postFix = option.label.substring(option.label.indexOf(".") + 1);
      let label = [this.getNodeName(), postFix].join(".");
      availableResources.push({
        nodeRef: this,
        selectedResourceId: this.id,
        path: option.path,
        label,
        context: option.context
      });
    }
    return availableResources;
  }
  async getAvailableResources() {
    let selectedResource = this.getSelectedResource();
    if (!selectedResource) return [];
    let availableResources = [];
    let splitted = selectedResource.label.split(".");
    let label = [this.getNodeName(), splitted[splitted.length - 1]].join(".");
    availableResources.push({
      nodeRef: this,
      selectedResourceId: this.id,
      path: "",
      label,
      context: selectedResource.context
    });
    if (!selectedResource.path) {
      let avRes = await this.getAvailableResourcesForAllPaths();
      availableResources = availableResources.concat(avRes);
    }
    return availableResources;
  }
  /**
   * get output keys for given resource(optional) from its own selected resource
   * @param params {resource} is one of its own available resources (FilterNodeId-Instances,FilterNodeId-addOns.Volumes)
   */
  async getOutputKeys(params) {
    let selectedResource = this.getSelectedResource();
    if (!selectedResource) return [];
    let { nodeRef } = selectedResource;
    if (!nodeRef) return [];
    return nodeRef.getOutputKeys(params);
  }
  validate() {
    return new validations_1.CustomNodeValidation().validate(this);
  }
  setId(props) {
    this.setBasicNodeId(props);
  }
}
exports.CustomNode = CustomNode;
//# sourceMappingURL=CustomNode.js.map
